import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {BaseFormComponent} from "../base-form/base-form.component";
import {FormBuilder, ReactiveFormsModule, Validators} from "@angular/forms";
import {RegimeModel} from "../../../models/regime.model";
import {ActivatedRoute} from "@angular/router";
import {StorageService} from "../../../services/internals/storage.service";
import {UserService} from "../../../services/repositories/user.service";
import {takeUntil} from "rxjs";
import {GestionErreursService} from "../../../services/gestion-erreurs.service";
import {RegimeService} from "../../../services/repositories/regime.service";
import { CommonModule } from '@angular/common';
import { InputFieldComponent } from '../../form-generator/fields/input-field/input-field.component';
import { DepFieldComponent } from '../../form-generator/fields/dep-field/dep-field.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    InputFieldComponent,
    DepFieldComponent,
    TranslateModule,
    ReactiveFormsModule,
    IonicModule
  ]
})
export class UserFormComponent extends BaseFormComponent {
  regimeModel: any = new RegimeModel();
  user: any;
  regimes: any = [];

  constructor(
    private regimeService: RegimeService,
    private userService: UserService,
    private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef,
    translateService: TranslateService,
    gestionErreursService: GestionErreursService,
  ) {
    super(translateService, gestionErreursService);
    this.repository = this.userService;
    this.form = this.formBuilder.group({
      nom: [null, Validators.required],
      prenom: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      telephone: [null, [Validators.required, Validators.pattern(/^\d{10}$/)]],
      regime_id: [null, [Validators.required]]
    });
  }

  setRegimeValue(value: any) {
    this.form.get('regime_id')?.setValue(value);
    if(value) {
      if(this.regimes[value] === null || this.regimes[value] === undefined) {
        this.regimeService.getOneById(value).then(req => {
          req.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
            next: (regime: any) => {
              this.regimes[value] = regime.description;
              this.cdRef.detectChanges()
            }
          })
        })
      }
    }
  }
}
